import React, { useEffect, useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import HomePage from './pages/HomePage';
import PrometheusPage from './pages/PrometheusPage';
import WhitepaperPage from './pages/WhitepaperPage';
import BrandPage from './pages/BrandPage';

const ROUTES = {
  '/prometheus': PrometheusPage,
  '/whitepaper': WhitepaperPage,
  '/brand': BrandPage,
};

function pageFor(pathname) {
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  return ROUTES[path] || HomePage;
}

export default function App() {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const Page = pageFor(path);

  return (
    <>
      <Page />
      <Analytics />
    </>
  );
}
